export function processingTable(content: TContent): TContent {
  const table = content.children[0];

  return { ...table, children: table.children.filter((elem) => elem.type !== 'figcaption') };
}
